function menu_bg_remove() {
  document.querySelectorAll(".dropdown_hover").forEach((bg) => {
    bg.classList.remove("bg-light");
  });
}

function addBadgeToDeodorantLink() {
  const deodorantLink = document.querySelector(
    '.navbar .nav-item a.dropdown-item[title="Natural Solid Deodorant"]'
  );

  if (deodorantLink) {
    const badge = document.createElement("span");

    badge.className = "new-badge";

    badge.textContent = "New";

    deodorantLink.appendChild(badge);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const dropdown_hover = document.querySelectorAll(".dropdown_hover");
  dropdown_hover.forEach((dropdown) => {
    dropdown.addEventListener("mouseover", () => {
      menu_bg_remove();
      dropdown.classList.add("bg-light");
      document.querySelectorAll(".navbar-hover").forEach((navbar) => {
        navbar.querySelectorAll(".dropdown-menu").forEach((close) => {
          close.classList.remove("show");
        });
      });
      const menu = dropdown.querySelector(".dropdown-menu");
      menu.classList.add("show");
      menu.setAttribute("data-bs-popper", "static");
    });
  });
  document.querySelectorAll(".dropdown-menu").forEach((menu) => {
    menu.addEventListener("mouseout", () => {
      menu.classList.remove("show");
      menu.removeAttribute("data-bs-popper");
      menu_bg_remove();
    });
  });

  addBadgeToDeodorantLink();

  function updateTitles() {
    const titles = document.querySelectorAll(
      "#sca-fg-today-offer-iframe .sca-offer-title"
    );
    titles.forEach((title) => {
      const text = title.textContent || "";
      let additionalText = "";

      if (text.includes("Mouthwash")) {
        additionalText = "Spend $100 to get ";
      } else if (text.includes("Hand Soap")) {
        additionalText = "Spend $150 to get ";
      } else if (text.includes("Suncare Duo")) {
        additionalText = "Spend $250 to get ";
      }

      if (additionalText && !title.dataset.modified) {
        title.textContent = additionalText + text;
        title.dataset.modified = "true";
      }
    });
  }

  function updateOffersCount(count) {
    document.querySelector('#sca-fg-today-offer-widget .sca-fg-count-offers').innerHTML = count;
  }

  function reorderOffers() {
    const container = document.querySelector(".sca-fg-offers");
    if (container) {
      const desiredOrder = ["65027", "65253", "65252"];
      const offers = Array.from(container.querySelectorAll(".sca-fg-offer"));

      offers.sort((a, b) => {
        const idA = a.getAttribute("data-fg-offer-id");
        const idB = b.getAttribute("data-fg-offer-id");
        return desiredOrder.indexOf(idA) - desiredOrder.indexOf(idB);
      });

      offers.forEach((offer, index) => {
        if (offer.dataset.order !== String(index)) {
          container.appendChild(offer);
          offer.dataset.order = String(index); // Mark as reordered
        }
      });

      updateOffersCount(desiredOrder.length);
    }
  }

  let isChecked = false;

  const observer = new MutationObserver(() => {
    const offerDiv = document.querySelector("#sca-fg-today-offer-iframe");
    if (offerDiv && !isChecked) {
      isChecked = true;

      const floatingWidgetObserver = new MutationObserver(() => {
        updateTitles();
        reorderOffers();
      });

      floatingWidgetObserver.observe(offerDiv, {
        childList: true,
        subtree: true,
      });

      updateTitles();
      reorderOffers();

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      updateTitles();
      reorderOffers();
    }
  });
});

document.addEventListener("animationend", function (event) {
  if (event.animationName === "klaviyo-fadeout") {
    const popup = document.querySelector(
      'div[aria-label="POPUP Form"][role="dialog"]'
    );

    if (popup) {
      popup.style.display = "none";
    }
  }
});
